import { Modal, Button } from '@/components/Elements';
import { queryClient } from '@/lib/react-query';
import { useUpdateTags } from '../api/dataCatalog/updateTags';
import { useUpdateColumnDetails } from '../api/dataCatalog/updateColumnDetails';

export const KDEntityTagModal = ({
  isOpen,
  handleCloseModal,
  entityCurrColumn,
  tags,
  connFlds,
  form,
  selectedColDetails,
  searchQuery,
  closeMainModal,
  setTable,
  setBkpSources,
  setSources,
}) => {
  const handleCloseModalHandler = () => {
    handleCloseModal();
  };

  const updateColDetails = useUpdateColumnDetails();

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleCloseModalHandler}
      title={'Updating Object View Tag?'}
      headerClassName="pt-4 px-3"
      titleClassName="text-sm leading-5 text-brand-ai-200"
      topStripClassName="hidden"
      topBorderClassname="border-t-4 border-pv-warning-warning-text"
      className="max-w-xl w-120 relative"
      closeClassName="right-3 top-4"
    >
      <div className="flex flex-col justify-between">
        <div className="p-3 flex flex-col gap-2">
          <p className="text-xs text-pv-text-primary-text">
            You can assign only one Object View tag per table.
          </p>
          <span className="text-pv-text-primary-text font-medium">
            {`Are you sure you want update your Object View tag for ${entityCurrColumn.tableName} from ${entityCurrColumn.colFromName} to ${entityCurrColumn.colToName}?`}
          </span>
        </div>
        <div className="border-t-2 mt-2 w-full">
          <div className="flex justify-between items-center py-4 px-3">
            <Button
              variant="ghost"
              className="bg-transparent shadow-none rounded-lg text-xs leading-5 font-normal px-2 py-1 hover:bg-pv-neutral-grey-100 text-pv-neutral-grey-600 hover:text-pv-neutral-grey-800"
              onClick={() => {
                handleCloseModalHandler();
              }}
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              className="bg-pv-primary-primary-500 rounded-lg text-xs leading-5 font-normal 
              px-2 py-1 hover:bg-pv-primary-primary-800"
              onClick={async () => {
                let selTags = tags.map((tag) => tag.id);
                let selConnFlds = connFlds.map((fld) => ({
                  foreignField: fld.foreignField,
                  table: fld.table,
                  tableId: fld.tableId,
                }));
                const data = {
                  label: form.label,
                  description: form.desc,
                  tags: selTags,
                  mappings: selConnFlds,
                };
                await updateColDetails.mutateAsync({
                  integId:
                    selectedColDetails.integrationId ||
                    selectedColDetails.tableDetails.integrationId,
                  tableId:
                    selectedColDetails.sourceId ||
                    selectedColDetails.dDSourceId,
                  columnName: selectedColDetails.name,
                  searchQuery: searchQuery,
                  data: data,
                });
                setBkpSources((prev) => {
                  let temp = structuredClone(prev);
                  temp[selectedColDetails.tableId].forEach((col, index) => {
                    if (col.name === selectedColDetails.name) {
                      let tempCol = structuredClone(col);
                      tempCol.description = form.desc;
                      tempCol.label = form.label;
                      tempCol.tags = tags;
                      tempCol.mappings = connFlds;
                      temp[selectedColDetails.tableId][index] = tempCol;
                    } else {
                      const ind = col.tags.findIndex(
                        (c) => c.name === 'Object View'
                      );
                      if (ind !== -1) {
                        let tempCol = structuredClone(col);
                        tempCol.tags = tempCol.tags.filter(
                          (t) => t.name !== 'Object View'
                        );
                        temp[selectedColDetails.tableId][index] = tempCol;
                      }
                    }
                  });
                  setSources(temp);
                  return temp;
                });
                handleCloseModal();
                setTable({});
                closeMainModal();
              }}
            >
              Update
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};
